<template>
	<div class="row">
		<div class="col-12 text-center mb-3">
			<h3 class="fs-2-5">Vuoi inserire altre classi?</h3>
		</div>
		<div class="col-12">
			<div class="row justify-content-center">
				<div class="col-xl-8 col-xxl-6">

					<form v-if="schoolType == 'primaria'" @submit.prevent="addClass">
						<div class="row align-items-center">
							<div class="col-md-4 form-group input-group input-group-lg mt-2" >
								<select name="classi" id="classi" class="form-control form-control-lg custom-select" required v-model="form.class">
									<option value="">Classe</option>
									<option value="1">1</option>
									<option value="2">2</option>
									<option value="3">3</option>
									<option value="4">4</option>
									<option
									value="5">5</option>
								</select>
							</div>
							<div class="col-md-4 form-group input-group input-group-lg mt-2">
								<select name="sezioni" id="sezioni" class="form-control form-control-lg custom-select" required v-model="form.section">
									<option value="">Sezione</option>
									<option value="A">A</option>
									<option value="B">B</option>
									<option value="C">C</option>
									<option value="D">D</option>
									<option value="E">E</option>
									<option value="F">F</option>
									<option value="G">G</option>
									<option value="H">H</option>
									<option value="I">I</option>
									<option value="L">L</option>
									<option value="M">M</option>
									<option value="N">N</option>
									<option value="O">O</option>
									<option value="P">P</option>
									<option value="Q">Q</option>
									<option value="R">R</option>
									<option value="S">S</option>
									<option value="T">T</option>
									<option value="U">U</option>
									<option value="V">V</option>
									<option value="Z">Z</option>
								</select>
							</div>
							<div class="col-md-4 form-group input-group input-group-lg text-right mt-2">
								<button type="submit" id="btn-add-cls" class="btn btn-yellow rounded-pill btn-sm px-3 py-0">
									<span class="va-sub">AGGIUNGI</span>
								</button>
							</div>
							<div class="col-12">{{errorMsg}}</div>
						</div>
					</form>

					<form v-if="schoolType == 'infanzia'" @submit.prevent="addClass">
						<div class="row">
							<div class="col-md-8 form-group input-group input-group-lg mt-2">
								<input type="text" class="form-control form-control-lg" placeholder="Nome classe" required v-model="form.section">
							</div>
							<div class="col-md-4 form-group input-group input-group-lg text-right mt-2">
								<button type="submit" id="btn-add-cls" class="btn btn-yellow rounded-pill btn-sm px-3 py-0">
									<span class="va-sub">AGGIUNGI</span>
								</button>
							</div>
						</div>
					</form>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'AddClassComponent',
	props: ['schoolType'],

	data() {
		return {
			ajaxObj: window.ajax_object,
			form: {
				section: '',
				class: ''
			},
			errorMsg:''
		}
	},

	methods: {
		addClass() {
			this.errorMsg  = ''
			let url = this.ajaxObj.ajax_url
			let _this = this

			let formData = new FormData();
			formData.append('action', 'nl_add_new_school_class')
			formData.append('_nounce_value', this.ajaxObj._nounce_value)
			formData.append('classe', this.form.class)
			formData.append('sezione', this.form.section)

			axios.post(url, formData)
				.then((response) => {
					console.log(response.data)
					if(response.data.error == '') {
						_this.$emit('on-added-class')
						_this.form.class = this.schoolType == 'infanzia' ? '0' : ''
						_this.form.section = ''
					} else {
						this.errorMsg  = response.data.error
					}
				}, (error) => {
					console.log(error);
				});
		}
	},

	mouted() {
		this.form.class = this.schoolType == 'infanzia' ? '0' : ''
	}
}
</script>
